import { Action } from './toast-types';
export class BaseToastStrategy {
    getActionPastTense(action) {
        switch (action) {
            case Action.Create:
                return 'created';
            case Action.Update:
                return 'updated';
            case Action.Delete:
                return 'deleted';
            default:
                return 'processed';
        }
    }
    getActionVerb(action) {
        switch (action) {
            case Action.Create:
                return 'create';
            case Action.Update:
                return 'update';
            case Action.Delete:
                return 'delete';
            default:
                return 'process';
        }
    }
    getSuccessMessage(action) {
        const entityName = this.getName();
        if (action) {
            const actionPastTense = this.getActionPastTense(action);
            return {
                title: 'Success!',
                message: `${entityName} ${actionPastTense} successfully.`,
            };
        }
        return {
            title: 'Success!',
            message: `${entityName} processed successfully.`,
        };
    }
    getErrorMessage(action) {
        const entityName = this.getName();
        if (action) {
            const actionVerb = this.getActionVerb(action);
            return {
                title: 'Error!',
                message: `Failed to ${actionVerb} ${entityName.toLowerCase()}.`,
            };
        }
        return {
            title: 'Error!',
            message: `Failed to process ${entityName.toLowerCase()}.`,
        };
    }
    getWarningMessage(action) {
        const entityName = this.getName();
        if (action) {
            const actionVerb = this.getActionVerb(action);
            return {
                title: 'Warning!',
                message: `Please check ${entityName.toLowerCase()} details before ${actionVerb}ing.`,
            };
        }
        return {
            title: 'Warning!',
            message: `Please check ${entityName.toLowerCase()} details.`,
        };
    }
    getInfoMessage(action) {
        const entityName = this.getName();
        if (action) {
            const actionPastTense = this.getActionPastTense(action);
            return {
                title: 'Info',
                message: `${entityName} will be ${actionPastTense}.`,
            };
        }
        return {
            title: 'Info',
            message: `${entityName} information updated.`,
        };
    }
}
